<script>
import { Pie } from 'vue-chartjs'

export default {
  extends: Pie,
  props: {
    /**
     * charthoz szükséges adat object
     */
    chartData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      /**
       * pie bar grafikon beállításai
       */
      options: {
        responsive: true,
        maintainAspectRatio: true,
        legend: {
          display: false,
        },
        legendCallback(chart) {
          const pieces = []
          pieces.push('<ul class="' + chart.id + '-legend pie-legend p-0 pl-2" style="list-style: none;">')
          for (let i = 0; i < chart.data.datasets[0].data.length; i++) {
            pieces.push('<li><span id="legend-' + i + '-item" style="background-color:' +
              chart.data.datasets[0].backgroundColor[i] + '; display: inline-block; width: 13px; height: 13px; margin-right: 5px;"></span>')
            if (chart.data.datasets[0].labels[i] && chart.data.datasets[0].percent[i]) {
              pieces.push('<span style="font-size: 15px;">')
              pieces.push(chart.data.datasets[0].percent[i] + '% ' + chart.data.datasets[0].labels[i])
              pieces.push('</span>')
            }
            pieces.push('</li>')
          }
          pieces.push('</ul>')
          return pieces.join('')
        },
        tooltips: {
          mode: 'index',
          intersect: true,
          callbacks: {
            label: function (tooltipItem, data) {
              return data.datasets[0].labels[tooltipItem.index] + ': ' + data.datasets[0].data[tooltipItem.index] + ' ' + data.datasets[0].unit
            },
          },
        },
      },
    }
  },
  mounted() {
    this.destroyAndRenderChart()
    window.addEventListener('resize', this.destroyAndRenderChart)
  },
  destroyed() {
    window.removeEventListener('resize', this.destroyAndRenderChart)
  },
  methods: {
    /**
     * jelenlegi chart ha létezik destroy, utáéna render
     */
    destroyAndRenderChart() {
      if (this.$data._chart) {
        this.$data._chart.destroy()
      }
      this.renderChart(this.chartData, this.options)
      this.$emit('legendGenerated', this.$data._chart.generateLegend())
    },
  },
}
</script>
